
const theme = {
  background: '#1B1E29',
  borderHeader: '#1B1E29',
  primary: '#FFF',
  secondary: '#FFF',
  constellationLogoColor: '#FFF',
  menuLabelColor: '#FFF',

  optionsHeaderPrimary: '#292D3A',
  optionsHeaderPrimaryDarken: '#252935',

  getDagGlowColor: '#1552EF',
  
  linkIconColor:'#252935',

  borderColor: '#252935',

  redirectLinkBackground: '#252935',

  sidebarBorderHeader: '#272B39',

  footerMailColor: '#272B37',
  footerLinksHeaderColor: '#FFF',

  constellationRightsColor: '#FFF',

  optionsDateAndButtonColor:'rgba(255, 255, 255, 0.66)',
  
  footerSocialMediaIconColor: "#6E717F",

  buttonPrimaryColor: '#313ED0',
  buttonPrimaryBorderColor: '#566FF0',
  buttonPrimaryHoverColor: '#1B1E29',
  buttonSecondaryColor: '#1B1E29',
  buttonSecondaryBorderColor: '#566FF0',
  buttonSecondaryHoverColor: '#566FF0',

  breakpoints: {
    mobile: "only screen and (max-width: 600px)",
    tablet: "only screen and (max-width: 1200px)",
    smallMobile: "only screen and (max-width: 300px)",
    "2xl": "only screen and (max-width: 1536px)",
    xl: "only screen and (max-width: 1280px)",
    lg: "only screen and (max-width: 1024px)",
    md: "only screen and (max-width: 768px)",
    sm: "only screen and (max-width: 430px)"
  }
};

export default theme;
